export default "__VITE_ASSET__WofrG6JU__"